{
  "step": 10,
  "frames": 36,
  "cols": 6,
  "rows": 6,
  "frame": 128
}
